export const reduceProductsResponse = data => {
  const productVersions = data.reduce((acc, product) => {
    const keyedVersions = {};
    product.productVersions.forEach(version => {
      keyedVersions[version.skuId] = version;
    });

    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    return Object.assign({}, acc, keyedVersions);
  }, {});
  const skuMap = Object.values(productVersions).reduce((acc, productVersion) => {
    /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    const skus = Object.assign({}, acc, {
      [productVersion.skuId]: productVersion
    });
    productVersion.quantityPackDetails.forEach(quantityPack => {
      skus[quantityPack.skuId] = quantityPack;
    });
    return skus;
  }, {});
  const products = data.reduce((acc, product) => {
    var _acc$product$id;
    const {
      id
    } = product;
    if (product.currentSkuId < (acc === null || acc === void 0 || (_acc$product$id = acc[product.id]) === null || _acc$product$id === void 0 ? void 0 : _acc$product$id.currentSkuId)) {
      return acc;
    }
    return Object.assign({}, acc, {
      [id]: Object.assign({}, product, {
        productVersions: product.productVersions.map(({
          skuId
        }) => skuId)
      })
    });
  }, {});
  const apiNameToProductId = Object.values(products).reduce((acc, {
    apiName,
    id
  }) => Object.assign({}, acc, {
    [apiName]: id
  }), {});
  const productLineLevelToProductId = Object.values(products).reduce((acc, {
    productLine,
    productLevel,
    id
  }) => {
    if (productLine) {
      if (productLine in acc) {
        return Object.assign({}, acc, {
          [productLine]: Object.assign({}, acc[productLine], {
            [productLevel]: id
          })
        });
      }
      return Object.assign({}, acc, {
        [productLine]: {
          [productLevel]: id
        }
      });
    }
    return acc;
  }, {});
  const quantityPackApiNameToProductId = Object.values(productVersions).reduce((acc, productVersion) => {
    productVersion.quantityPackDetails.forEach(quantityPack => {
      const {
        productId,
        productApiName,
        quantityPackApiName
      } = quantityPack;
      if (quantityPackApiName) {
        acc[quantityPackApiName] = Object.assign({}, acc[quantityPackApiName], {
          [productApiName]: productId
        });
      }
    });
    return acc;
  }, {});
  return {
    productMap: products,
    productVersions,
    skuMap,
    apiNameToProductId,
    productLineLevelToProductId,
    quantityPackApiNameToProductId,
    rawProductList: data
  };
};